import { useQuery } from '@tanstack/react-query';
import { REPORT_EMAILS_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ReportEmailsApiV2 } from 'Data/ReportEmails.api.v2';

interface IUseQueryPreference {
  enabled: boolean;
}

export const useQueryReportEmails = ({ enabled }: IUseQueryPreference) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [REPORT_EMAILS_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    retry: false,
    enabled,
    queryFn: async () => {
      const response = await ReportEmailsApiV2.getReportEmails();
      return response.data;
    },
  });

  return {
    data,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
